import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { DetailModel } from '@bsuccess/models/project/detail.model';
import { locale as english } from '../../../../../i18n/studio/projects/project/dialogs/detail-update-dialog/en';
import { locale as frensh } from '../../../../../i18n/studio/projects/project/dialogs/detail-update-dialog/fr';
import { locale as arabic } from '../../../../../i18n/studio/projects/project/dialogs/detail-update-dialog/ar';

@Component({
    selector: 'detail-update-dialog',
    templateUrl: './detail-update-dialog.component.html',
    styleUrls: ['./detail-update-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DetailUpdateDialogComponent implements OnInit {
    detailObject: DetailModel;
    error$: Observable<string>;
    composeForm: UntypedFormGroup;
    constructor(
        public dialogRef: MatDialogRef<DetailUpdateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: DetailModel,
        private translationLoaderService: FuseTranslationLoaderService,
        public translateService: TranslateService,
    ) {
        this.translationLoaderService.loadTranslations(english, frensh, arabic);
        this.composeForm = this.createComposeForm();
        this.dialogRef.disableClose = true;
    }

    createComposeForm(): UntypedFormGroup {
        return new UntypedFormGroup({
            title: new UntypedFormControl(''),
            description: new UntypedFormControl(''),
        });
    }
    saveParagraph(): void {
        this.detailObject = {
            _id: this._data._id,
            title: this.composeForm.value.title,
            description: this.composeForm.value.description,
        };
    }
    ngOnInit(): void {
        this.composeForm.controls['title'].setValue(this._data.title);
        this.composeForm.controls['description'].setValue(
            this._data.description
        );
    }
}
